import React from 'react';
import uuid4 from 'uuid/v4';

import ErrorBlock from 'components/ErrorBlock';

import './styles.css';

const IntegrationInfo = ({featureInfo}) => {
  const featureErrors = featureInfo.errors.filter(error => error !== '');
  const featureMessages = featureInfo.messages;

  return (
    <div className="IntegrationInfo">
      {featureMessages &&
        featureMessages.map(msg => (
          <div key={uuid4()} className="displayMessage">
            {msg}
          </div>
        ))}
      {featureErrors &&
        featureErrors.map(error => (
          <ErrorBlock key={uuid4()}>{error}</ErrorBlock>
        ))}
    </div>
  );
};

export default IntegrationInfo;
